import { stringifyFixtureId } from 'react-cosmos-core';
import { stringifyElementId } from './shared.js';
const DEFAULT_EXPANSION = {};
export function getFixtureExpansion(groupExpansion, fixtureId) {
    return groupExpansion[stringifyFixtureId(fixtureId)] || DEFAULT_EXPANSION;
}
export function updateElementExpansion(groupExpansion, fixtureId, elementId, treeExpansion) {
    const strFixtureId = stringifyFixtureId(fixtureId);
    const strElementId = stringifyElementId(elementId);
    return {
        ...groupExpansion,
        [strFixtureId]: {
            ...groupExpansion[strFixtureId],
            [strElementId]: treeExpansion,
        },
    };
}
